import { SUPPORT_URL } from '@mote/helpers/constants'
import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const MoteIdUndefinedError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='Recording Unsuccessful'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          We were unable to complete the recording. Please check your internet
          connection and try again or{' '}
          <a href={SUPPORT_URL} name='faq' target='_blank' rel='noreferrer'>
            kindly contact support
          </a>{' '}
        </Text>
      }
      buttons={
        <Button onClick={onClose} variant='primary-inverted' text='Dismiss' />
      }
    />
  )
}
